module.exports = __webpack_public_path__ + "img/Inicio3.71967f56.png";